<template>
  <div>
    <h1>Video goes here</h1>
    <button @click="$emit('conditions_met', 'video')">woop</button>
  </div>
</template>
<script>
export default {
  data: function () {
    return {};
  },
  mounted() {},
  methods: {
    capture: function () {
      const constraints = {
        video: true
      };

      console.log(navigator.mediaDevices);
      /*
        navigator.mediaDevices.getUserMedia(constraints).
          then((stream) => {video.srcObject = stream});
        }
        */
      const video = document.querySelector('video');
      console.log(navigator);
    }
  }
};
</script>
